import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        },
        rejectedBookings: {
            type: Number,
            required: true
        },
        cancelledBookings: {
            type: Number,
            required: true
        },
        allBookingsCount: {
            type: Number,
            required: true
        }
    },
    computed: {
        data() {
            return {
                datasets: [{
                    label: "Rejected Vs Cancelled Bookings",
                    data: [this.rejectedBookings, this.cancelledBookings],
                    backgroundColor: ["#F00", "#F0F"]
                }],
                labels: [`Rejected  (${this.rejectedBookings/this.allBookingsCount*100}%)`, `Cancelled (${this.cancelledBookings/this.allBookingsCount*100}%)`]
            }
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    }
};